/* Add additional forum-specific routes in this file. Use addRoute if they're new, or overrideRoute
   if they replace an existing route. */

export const lwRoutes = () => {
  // overrideRoute(
  //   {
  //     path:'/login',
  //     name: 'Login',
  //     componentName: "NewForumLoginPage",
  //   }
  // );
};
